export default {
  props: {
    ripple: {
      type: Boolean,
      default: true
    },
    rippleColor: {
      type: String,
      default: ''
    },
    rippleOpacity: {
      type: Number
    }
  }
};



// WEBPACK FOOTER //
// ./src/muse-ui/internal/mixins/ripple.js